
const ageToYear = (age) => {
    const d = new Date();
    const year = d.getFullYear();
    const birthYear = year-age ; 
    return birthYear;
};
export const yearToAge = (birthYear) => {
    const d = new Date();
    const currentYear = d.getFullYear();
    const age = currentYear-birthYear ; 
    return age;
};

export default ageToYear;